export default __webpack_public_path__ + "static/media/close_dark.63300067.svg";